import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import css from './PricePeriodsComponent.module.css';
import {periodsActions} from "../../../store/slices/settings-slices";
import PricePeriodSingleComponent from "../PricePeriodSingleComponent/PricePeriodSingleComponent";


const PricePeriodsComponent = ({isShow}) => {
    const dispatch = useDispatch();
    const { periods, trigger } = useSelector((store) => store.periods);

    useEffect(() => {
        dispatch(periodsActions.getAllPeriods());
    }, [trigger]);


    return (
        <div className={css.wrap}>
            <div className={css.header}>
                <div className={css.headerPack}>Days count</div>
                <div className={css.headerPrice}>Discount (%)</div>
            </div>

            {periods && periods.map((obj) => <PricePeriodSingleComponent
                key={obj.id}
                period={obj}
            />)}
        </div>
    );
};

export default React.memo(PricePeriodsComponent);